__turbopack_context__.v({
  "btnStyles": "myWP1a_btnStyles",
  "container": "myWP1a_container",
  "pageTitle": "myWP1a_pageTitle",
});
